import { Stack } from '@mui/material'

import { FieldHeader } from '../FieldHeader'
import { EditTimeWindows } from './components/EditTimeWindows'

import { useTexts } from '../../hooks/useTexts'
import { useActions } from './hooks/useActions'

type Props = {
  label: string
  testId?: string
  value: [uui.domain.rm.TimeWindow?, uui.domain.rm.TimeWindow?]
  disabled: boolean
  validate: (force?: boolean) => void
  onChange: (value: [uui.domain.rm.TimeWindow?, uui.domain.rm.TimeWindow?]) => void
}

export function TimeWindows(props: Props) {
  const { label, testId = 'timeWindows', value, disabled, validate, onChange } = props

  const texts = useTexts()

  const actions = useActions(value, onChange)

  const addTimeWindowDisabled = value.length === 2

  return (
    <Stack data-testid={testId} data-trackid={testId} gap={2}>
      <FieldHeader
        label={label}
        testId={`${testId}-section-header`}
        action={{
          label: texts.addTimeWindowsLabel,
          tooltip: texts.addTimeWindowTooltip,
          disabledTooltip: texts.addTimeWindowDisabledTooltip,
          onClick: actions.onAddTimeWindow,
          disabled: addTimeWindowDisabled || disabled,
        }}
      />

      <EditTimeWindows
        onUpdateTimeWindow={actions.onUpdateTimeWindow}
        onRemoveTimeWindow={actions.onRemoveTimeWindow}
        validate={validate}
        value={value}
        disabled={disabled}
      />
    </Stack>
  )
}
